import React, { useState } from 'react';
import { Upload, Loader2, FileText, CheckCircle2 } from 'lucide-react';
import { adminImportSeriesCsv, adminImportEpisodesCsv } from '../../services/cms';
import { useToast } from '../../hooks/use-toast';

const Block = ({ title, columns, onImport, example }) => {
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const { toast } = useToast();
  const handle = async (file) => {
    if (!file) return;
    setBusy(true); setResult(null);
    try { const r = await onImport(file); setResult(r); toast({ title: 'Import terminé', description: `${r.created} ligne(s) importée(s).` }); }
    catch (e) { toast({ title: 'Échec de l’import', description: e?.response?.data?.detail || 'Erreur' }); }
    finally { setBusy(false); }
  };
  return (
    <div className="bg-card border border-border rounded-2xl p-6">
      <h3 className="font-display font-700 text-lg mb-2 flex items-center gap-2"><FileText className="w-5 h-5 text-primary" /> {title}</h3>
      <p className="text-sm text-muted-foreground mb-1">Colonnes attendues :</p>
      <code className="block text-xs bg-muted rounded-lg p-3 mb-3 overflow-x-auto">{columns}</code>
      <p className="text-xs text-muted-foreground mb-4">Exemple : <span className="font-mono">{example}</span></p>
      <label className="flex items-center justify-center gap-3 border-2 border-dashed border-primary/40 rounded-xl p-6 cursor-pointer hover:bg-primary/5 transition-colors">
        {busy ? <Loader2 className="w-5 h-5 animate-spin text-primary" /> : <Upload className="w-5 h-5 text-primary" />}
        <span className="font-700 text-sm">{busy ? 'Import en cours…' : 'Choisir un fichier CSV'}</span>
        <input type="file" accept=".csv,text/csv" className="hidden" disabled={busy} onChange={(e) => handle(e.target.files[0])} />
      </label>
      {result && <p className="flex items-center gap-2 text-sm font-700 text-green-600 mt-3"><CheckCircle2 className="w-4 h-4" /> {result.created} créé(s){result.skipped != null ? `, ${result.skipped} ignoré(s)` : ''}</p>}
    </div>
  );
};

const CsvImport = () => (
  <div className="grid md:grid-cols-2 gap-6">
    <Block title="Import des séries"
      columns="titre, slug, auteur, resume, couverture_url, collection, statut, ordre_affichage, date_publication"
      example="La Rochelle,la-rochelle,F. Tallon,Un résumé,https://img,escapades,publie,1,2025-09-01"
      onImport={adminImportSeriesCsv} />
    <Block title="Import des épisodes"
      columns="serie_slug, numero, titre, slug, resume_court, image_couverture_url, statut, ordre_affichage, date_publication"
      example="la-rochelle,1,Le port,le-port,Résumé,https://img,publie,1,2025-09-01"
      onImport={adminImportEpisodesCsv} />
  </div>
);

export default CsvImport;
